export enum MATERIAL_SOURCE_CODE {
    ORDERED = 'ORDERED',
    SPLIT = 'SPLIT',
    BOOTSTOCK = 'BOOTSTOCK',
    OTHERSTOCK = 'OTHERSTOCK',
    OTHER = 'OTHER',
}

export interface JsonMaterialSourceModel {
    sourceCode: MATERIAL_SOURCE_CODE;
}

export class MaterialSourceModel {
    public constructor(public sourceCode: MATERIAL_SOURCE_CODE) {}
    public isNotOrdered(): boolean {
        return this.sourceCode !== MATERIAL_SOURCE_CODE.ORDERED;
    }
    public isOrdered(): boolean {
        return this.sourceCode === MATERIAL_SOURCE_CODE.ORDERED;
    }
    public isOther(): boolean {
        return this.sourceCode === MATERIAL_SOURCE_CODE.OTHER;
    }
    public isFromStock(): boolean {
        return (
            this.sourceCode === MATERIAL_SOURCE_CODE.BOOTSTOCK || this.sourceCode === MATERIAL_SOURCE_CODE.OTHERSTOCK
        );
    }
}

export class MaterialSourceModelFromJson extends MaterialSourceModel {
    public constructor(data: JsonMaterialSourceModel) {
        super(data.sourceCode);
    }
}
